import { useSelector } from "react-redux";
import { getDCUIPrimaryBtnColor, getDCUIPrimaryBtnTextColor, getGeneralTheme } from "@redux/selectors/verification-configuration-selectors";
import { CSSProperties } from "react";
import { ButtonWithSpinner } from "../button-with-spinner/button-with-spinner";

type PrimaryButtonProps = {
    id?: string;
    type: "button" | "submit" | "reset";
    disabled: boolean;
    label: string;
    buttonSize?: "sm" | "lg";
    hideSpinner?: boolean;
    className?: string;
    automationId?: string;
    onClick?: () => void;
};

export const PrimaryButton = (props: PrimaryButtonProps) => {
    const { id, hideSpinner, type, disabled, label, buttonSize, className, automationId, onClick } = props;
    const generalTheme = useSelector(getGeneralTheme);
    const dcuiPrimaryBtnColor = useSelector(getDCUIPrimaryBtnColor);
    const dcuiPrimaryBtnTextColor = useSelector(getDCUIPrimaryBtnTextColor);

    const buttonBGColor = generalTheme.mainColor || dcuiPrimaryBtnColor;
    const buttonTextColor = generalTheme.mainTextColor || dcuiPrimaryBtnTextColor;

    const primaryButtonStyle: CSSProperties = {
        borderColor: buttonBGColor,
        background: buttonBGColor,
        color: buttonTextColor
    };

    return (
        <ButtonWithSpinner
            id={id}
            automationId={automationId}
            style={primaryButtonStyle}
            disabled={disabled}
            hideSpinner={hideSpinner}
            label={label}
            type={type}
            buttonSize={buttonSize}
            className={className}
            onClick={onClick}
        />
    );
};